import { CustomProvider } from 'rsuite';
import { useTranslation } from 'react-i18next';
import enUS from 'rsuite/locales/en_US';
import frFR from 'rsuite/locales/fr_FR';

/**
 * A wrapper around rsuite's CustomProvider that automatically applies localization
 * based on the current i18next language setting.
 * 
 * @param {{ children: React.ReactNode }} props
 */
const RsuiteProvider = ({ children }) => {
    const { i18n } = useTranslation();
    
    const getRsuiteLocale = () => {
        const language = i18n.language || 'en';
        return language.startsWith('fr') ? frFR : enUS;
    };

    return (
        <CustomProvider locale={getRsuiteLocale()}>
            {children}
        </CustomProvider>
    );
};

export default RsuiteProvider;

